<template>
  <div class="bg-white" style="padding-bottom:80px">
    <!-- <Head></Head> -->
    <section class="w">
      <div class="part">
      <h1>{{ $t('Home.terms.AboutUs.AboutUs') }}</h1>
    </div>
    <div class="part">
      <h2>{{ $t('Home.terms.AboutUs.WelcomeToKakaClo') }}</h2>
      <p>{{ $t('Home.terms.AboutUs.Tips1') }}</p>
      <p>{{ $t('Home.terms.AboutUs.Tips2') }}</p>
      <p>{{ $t('Home.terms.AboutUs.Tips3') }}</p>
    </div>
    <img src="https://www.9-bill.com/index/legal"/>

    </section>
  </div>
</template>

<script>
export default {
  name: 'termsConditions'

}
</script>

<style lang="scss" scoped>
@import '../css/term.scss';
</style>
